const SORTABLE_METHOD = 'GET';

const normalizeRequestUrl = (config = {}) => {
  const browserOrigin =
    typeof window !== 'undefined' ? window.location?.origin : '';
  const base = config.baseURL || browserOrigin || 'http://localhost';
  const url = new URL(config.url || '', base);
  const params = new URLSearchParams(url.search);

  const configParamEntries =
    config.params instanceof URLSearchParams
      ? [...config.params.entries()]
      : Object.entries(config.params || {});
  configParamEntries.forEach(([key, rawValue]) => {
    const values = Array.isArray(rawValue) ? rawValue : [rawValue];
    values.forEach((value) => {
      if (value !== undefined && value !== null) params.append(key, String(value));
    });
  });

  const sorted = [...params.entries()].sort(([leftKey, leftValue], [rightKey, rightValue]) => {
    const keyOrder = leftKey.localeCompare(rightKey);
    return keyOrder || leftValue.localeCompare(rightValue);
  });
  url.search = '';
  url.hash = '';
  sorted.forEach(([key, value]) => url.searchParams.append(key, value));
  return url.toString();
};

export const buildGetDedupKey = (config = {}) => {
  const method = String(config.method || 'get').toUpperCase();
  if (method !== SORTABLE_METHOD) return '';
  return `${method}:${normalizeRequestUrl(config)}`;
};

export const createInFlightDedupAdapter = (adapter) => {
  const inFlight = new Map();

  return (config = {}) => {
    const method = String(config.method || 'get').toUpperCase();
    const canDeduplicate =
      method === SORTABLE_METHOD &&
      config.noDedup !== true &&
      !config.signal &&
      !config.cancelToken;

    if (!canDeduplicate) return adapter(config);

    const key = buildGetDedupKey(config);
    const existing = inFlight.get(key);
    if (existing) return existing;

    let request;
    try {
      request = Promise.resolve(adapter(config));
    } catch (error) {
      request = Promise.reject(error);
    }
    const pending = request.finally(() => {
      if (inFlight.get(key) === pending) inFlight.delete(key);
    });
    inFlight.set(key, pending);
    return pending;
  };
};
